import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Swiper from 'react-id-swiper';
import moment from 'moment-timezone';
import { IndexPageSection, PromotionCard } from "../../components";
import { Triangle } from '../../utils';
import {
  PromotionsSlider,
  OurPromotionsSlide,
  OurPromotionsNavigation,
  OurPromotionsButton,
} from './styles';

import Coctail from '../../assets/img/promotions/coctail.jpg';
import Selfie from '../../assets/img/promotions/selfie.jpg';
import Discount from '../../assets/img/promotions/discount.jpg';
import Newsletter from '../../assets/img/promotions/newsletter.jpg';
import Cocktails from '../../assets/img/promotions/cocktail.jpg';

class OurPromotions extends Component {
  static propTypes = {
    city: PropTypes.instanceOf(Object),
  };

  constructor(props) {
    super(props);
    this.swiper = null;
  }

  goNext = () => {
    if (this.swiper) this.swiper.slideNext();
  };

  goPrev = () => {
    if (this.swiper) this.swiper.slidePrev();
  };

  render() {

    const params = {
      slidesPerView: 1,
      spaceBetween: 30,
      breakpointsInverse: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    };

    return (
      <IndexPageSection
        heading={(
          <Fragment>
            Our <span>promotions</span>
          </Fragment>
        )}
        headerAdditional={(
          <OurPromotionsNavigation>
            <OurPromotionsButton onClick={this.goPrev}>
              <Triangle width={12} height={9} />
            </OurPromotionsButton>
            <OurPromotionsButton onClick={this.goNext}>
              <Triangle width={12} height={9} />
            </OurPromotionsButton>
          </OurPromotionsNavigation>
        )}
        hasRelativePosition
      >
        <PromotionsSlider>
          <Swiper
            {...params}
            ref={node => {
              if (node) {
                this.swiper = node.swiper;
              }
            }}
          >
            <OurPromotionsSlide>
              <PromotionCard
                img={Selfie}
                heading="Give a gift of Daycation"
                description="Gift of Relaxation and Pampering"
                link="https://www.blog.dayaxe.com/giftcards"
              />
            </OurPromotionsSlide>
            <OurPromotionsSlide>
              <PromotionCard
                img={Coctail}
                heading="Friends with Benefits"
                description="Get $5 for every friend you refer"
                link="https://www.blog.dayaxe.com/referral"
              />
            </OurPromotionsSlide>
            <OurPromotionsSlide>
              <PromotionCard
                img={Cocktails}
                heading="Gold Pass"
                description="Unlimited monthly access to any hotel in any location"
                link="https://www.blog.dayaxe.com/goldpass"
              />
            </OurPromotionsSlide>
            <OurPromotionsSlide>
              <PromotionCard
                img={Discount}
                heading="Easter Sale!"
                description={<Fragment>Up to <span>25%</span> off your order</Fragment>}
                link={`/s/los-angeles/day-passes?product=Day%20Pass%2CCabana%2CSpa%20Pass%2CDaybed%2CFitness%20Passes%2CEvents&market=Los%20Angeles%2CCA&date=${moment().format('YYYY-MM-DD')}&guests=2&priceHi=300&priceLo=0&distanceHi=0&distanceLo=0&sortType=2&experience=Festive%2CFamily%2CTranquil`}
              />
            </OurPromotionsSlide>
            <OurPromotionsSlide>
              <PromotionCard
                img={Newsletter}
                heading={<Fragment>Save <span>15%</span> Off Your First Purchase</Fragment>}
                description="Be the first to know when we add new luxury hotels and run special offers & sales."
                type="promo"
              />
            </OurPromotionsSlide>
          </Swiper>
        </PromotionsSlider>
      </IndexPageSection>
    );
  }
}

export default withTheme(OurPromotions);
